import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { JobidCardDetailService } from "@shared/services/jobid-card-detail/jobid-card-detail.service";
import { JOB_ID_CARD_DETAIL_ROUTES_NAMES } from "@routes/jobid-card/jobid-card.routes";
import { tap } from "rxjs/operators";
import { capitalizeFirstCharacter } from "@shared/utils";
import {
  AppConfirmationModalComponent,
  ModalType,
} from "@shared/components/modal/app-yes-no-modal/app-confirmation-modal.component";

@Injectable()
export class EditModeGuard {
  private readonly modalService: NgbModal = inject(NgbModal);
  private readonly jobIdCardDetailService: JobidCardDetailService = inject(JobidCardDetailService);

  private readonly excludedRoutes: string[] = [
    JOB_ID_CARD_DETAIL_ROUTES_NAMES.DISCUSSIONS,
    JOB_ID_CARD_DETAIL_ROUTES_NAMES.PRIMAVERA,
    JOB_ID_CARD_DETAIL_ROUTES_NAMES.HISTORY,
  ];

  canActivateChild(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    const url = _route.url[0]?.path || '';
    let isExcludedRoute = !this.excludedRoutes.every((route) => !url.includes(route));
    if (isExcludedRoute) {
      return this.jobIdCardDetailService.isModeReadOnly$.pipe(
        tap((readonly) => {
          if (!readonly) {
            AppConfirmationModalComponent.open(
              {
                title: "Job Card in Edit mode",
                content: "You have unsaved changes on this page.",
                subContent: `Please validate the Job Card before accessing the ${capitalizeFirstCharacter(url)} Tab.`,
                modalType: ModalType.OK,
                iconName: "warning",
              },
              this.modalService,
            );
          }
        }),
      );
    }
    return true;
  }
}
